<template>
  <div>
    <div
      v-if="!isIos()"
      class="speaker-icon"
      id="speaker-icon"
      @click="toggleSpeaker()">
      <b-tooltip
        target="speaker-icon"
        triggers="hover"
        placement="left"
      >{{ speaker ? $t('MEETING.MUTE_AUDIO') : $t('MEETING.UNMUTE_AUDIO') }}
      </b-tooltip>
      <volume-high-icon
        v-if="speaker"
        id="speaker"
        :size="24"
        title=""/>
      <volume-off-icon
        v-else
        id="speaker-off"
        :size="24"
        title=""/>
    </div>
    <b-navbar
      class="fixed-top"
      type="dark"
      variant="dark">
      <b-button
        v-if="isModerator"
        :variant="recording ? 'red' : 'green'"
        size="sm"
        class="recordBtn"
        @click="toggleRecording()">
        {{ recording ? $t('MEETING.STOP_RECORDING') : $t('MEETING.START_RECORDING') }}
      </b-button>
      <b-navbar-brand class="mx-auto mobilePush">
        <b
          v-if="meetingName"
          class="meeting-title">
          {{ meetingName }}
        </b>
        <information-outline-icon
          :size="19"
          class="infoTrigger"
          fill-color="#BBBBBB"
          @click="launchInfo()"
        />
        <moderator-key-icon
          v-if="!isModerator"
          id="moderator"
          :size="19"
          class="infoTrigger"
          fill-color="#BBBBBB"
          @click="launchMakeModerator()"
        />
        <b-tooltip
          target="moderator"
          triggers="hover"
        >{{ $t('MEETING.ENTER_MOD_KEY') }}
        </b-tooltip>
      </b-navbar-brand>
    </b-navbar>
    <b-modal
      id="meeting-info"
      ref="meetingInfo"
      :hide-header="true"
      :cancel-disabled="true"
      content-class="info"
      ok-title="Done"
      button-size="sm"
      ok-variant="primary"
    >
      <b-container
        fluid
        class="p-0">
        <span
          class="closeInfo"
          @click="$refs.meetingInfo.hide()"><window-close-icon/></span>

        <b-row no-gutters>
          <b-col>
            <b-row no-gutters>
              <b-col>
                <h4>{{ meetingInfo.title }}
                  <small
                    v-if="meetingInfo.start && !meetingInfo.isRoom"
                    class="d-block">
                    <span v-show="isPM(meetingInfo.start) === isPM(meetingInfo.end)">
                      {{ meetingInfo.start | moment('dddd, MMMM D &nbsp;•&nbsp;  h:mm') }}
                    </span>
                    <span v-show="isPM(meetingInfo.start) !== isPM(meetingInfo.end)">
                      {{ meetingInfo.start | moment(' dddd, MMMM D &nbsp;•&nbsp; h:mma') }}
                    </span>
                  - {{ meetingInfo.end | moment('h:mma') }}</small>
                </h4>
              </b-col>
            </b-row>
            <hr>
            <b-row
              v-if="!meetingInfo.guest"
              class="details">
              <b-col sm="12">
                <video-conference-icon
                  :size="19"
                  fill-color="#4A4A4A"
                  class="icon"/>
                {{ $t('MEETING.MEETING_ID') }}
                <span class="detail copymtg">{{ meetingInfo.ID }}</span>
                <copy-content-icon
                  :size="19"
                  fill-color="#4A4A4A"
                  class="icon"
                  @click="copyMeetingId()"/>
              </b-col>
              <b-col sm="6">
                <lock-outline-icon
                  :size="19"
                  fill-color="#4A4A4A"
                  class="icon"/>
                {{ $t('MEETING.MEETING_MODKEY') }} <div class="detail modkey">{{ meetingInfo.isModerator ? meetingInfo.moderatorKey : '****' }}</div>
              </b-col>
              <b-col sm="6">
                {{ $t('MEETING.MEETING_ACCESSKEY') }} <div class="detail pin">{{ meetingInfo.accessPin }}</div>
              </b-col>
              <b-col sm="12">
                <lock-outline-icon
                  :size="19"
                  fill-color="#4A4A4A"
                  class="icon"/>
                {{ $t('MEETING.DIALIN_NUMBERS') }}
                <div
                  v-for="(phoneNumber, index) in meetingInfo.phoneNumbers"
                  class="detail phones"
                  :key="index">
                  {{ phoneNumber }}
                </div>
                <div
                  v-if="meetingInfo.phonePin"
                  class="detail phones">
                  Phone PIN: {{ meetingInfo.phonePin }}
                </div>
              </b-col>
            </b-row>
            <b-row
              v-if="meetingInfo.guest"
              class="details">
              <b-col style>
                <video-conference-icon
                  :size="19"
                  fill-color="#4A4A4A"
                  class="icon"/>
                {{ $t('MEETING.MEETING_ID') }}
                <span class="detail copymtg">{{ meetingInfo.ID }}</span>
                <copy-content-icon
                  :size="19"
                  fill-color="#4A4A4A"
                  class="icon"
                  @click="copyMeetingId()"/>
              </b-col>
            </b-row>
            <hr v-if="!meetingInfo.guest">
            <b-row
              v-if="!meetingInfo.guest"
              class="smallDetails">
              <b-col class="col-4">
                <information-outline-icon
                  :size="19"
                  class="float-left"/>
                {{ $t('MEETING.MEETING_COMMUNITY') }} <b>{{ meetingInfo.communityName }}</b>
              </b-col>
              <b-col class="col-4">
                {{ $t('MEETING.MEETING_BOOKED_BY') }}<b>{{ meetingInfo.bookedBy }}</b>
              </b-col>
              <b-col class="col-4">
                {{ $t('MEETING.MEETING_TYPE') }}<b>{{ meetingInfo.type }}</b>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <hr
        v-if="!meetingInfo.guest"
        style="margin-bottom: 0px;">
      <template #modal-footer="{ close}">
        <b-dropdown
          v-if="!meetingInfo.guest"
          id="copy"
          :text="updateInviteDropbox()"
          :disabled="!Object.keys($parent.meetingInfo).length > 0"
          split
          variant="secondary-light"
          @click="copy(copied ? copied : 'Invitation' )">
          <b-dropdown-item
            v-if="copied && copied != 'Invitation'"
            @click="copy('Invitation')"><span>{{ $t('MEETING.COPY_INVITE') }}</span></b-dropdown-item>
          <b-dropdown-item
            v-if="copied != 'App Link'"
            @click="copy('App Link')"><span>{{ $t('MEETING.COPY_APPLINK') }}</span></b-dropdown-item>
          <b-dropdown-item
            v-if="copied != 'Web Link'"
            @click="copy('Web Link')"><span>{{ $t('MEETING.COPY_WEBLINK') }}</span></b-dropdown-item>
        </b-dropdown>
        <button
          v-if="!meetingInfo.guest"
          type="button"
          class="btn btn-primary btn-sm ms-auto"
          @click="close()">{{ $t('MEETING.MEETING_DONE') }}</button>
      </template>
    </b-modal>
    <b-modal
      id="recording-download"
      ref="recordingDownload"
      :hide-header="true"
      :hide-footer="true"
      content-class="info"
      centered>
      <b-container
        fluid
        class="p-0">
        <h4>{{ $t('MEETING.POPUP_RECORDING_FINISHED') }}</h4>
        <p>{{ $t('MEETING.RECORDING_AVAILABLE') }}
          <small class="recordingHint">{{ $t('MEETING.RECORDING_HINT') }}</small>
        </p>
        <div class="recordingActions">
          <b-button
            variant="primary"
            size="sm"
            :disabled="finalizeRemaining > 0"
            @click="downloadRecording()">{{ finalizeRemaining > 0 ? ( $t('MEETING.RECORDING_PROCESSING') + ' ' + finalizeRemaining + 's') : 'Download' }}</b-button>
          <b-button
            variant="secondary-light"
            size="sm"
            class="ml-2"
            @click="$refs.recordingDownload.hide()">{{ $t('MEETING.RECORDING_CLOSE') }}</b-button>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import DialpadIcon from "icons/Dialpad"
import PhoneIcon from "icons/Phone"
import VideoConferenceIcon from "../icons/VideoConference";
import CopyContentIcon from "../icons/CopyContent";
import MenuIcon from "icons/Menu"
import InformationOutlineIcon from "icons/InformationOutline"
import MessageIcon from "icons/Message"
import LockIcon from "icons/Lock"
import ModeratorKeyIcon from "../icons/ModeratorKey"
import LockOutlineIcon from "icons/LockOutline"
import WindowCloseIcon from "icons/WindowClose"
import VolumeHighIcon from "icons/VolumeHigh"
import VolumeOffIcon from "icons/VolumeOff"
import AccountMultipleIcon from "icons/AccountMultiple"
import {ref} from "@vue/composition-api";
import { isIos } from "../functions/browserDetails"
import { gaEvent } from "../functions/gtag";

export default {
  name: 'NavBarJitsi',
  components: {
    MenuIcon,
    PhoneIcon,
    DialpadIcon,
    AccountMultipleIcon,
    MessageIcon,
    LockIcon,
    LockOutlineIcon,
    InformationOutlineIcon,
    VideoConferenceIcon,
    CopyContentIcon,
    WindowCloseIcon,
    ModeratorKeyIcon,
    VolumeHighIcon,
    VolumeOffIcon,
  },
  props: {
    meetingInfo: {
      type: Object,
      default: () => {
      }
    },
    meetingName: {
      type: String,
      default: ""
    },
    isModerator: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const copied = ref(false)
    const timeout = ref(null)
    const speaker = ref(true)
    const recording = ref(false)
    const recordingLink = ref('')
    // JaaS keeps finalizing the file for a few seconds after recording stops;
    // downloading immediately yields an incomplete file, so the Download button
    // is gated by this countdown (mirrors uc-web-v2 PR #2401).
    const FINALIZE_MS = 10000
    const recordingStoppedAt = ref(null)
    const finalizeRemaining = ref(0)
    let finalizeTimer = null

    function updateFinalizeRemaining() {
      const stoppedAt = recordingStoppedAt.value
      finalizeRemaining.value = stoppedAt
        ? Math.max(0, Math.ceil((FINALIZE_MS - (Date.now() - stoppedAt)) / 1000))
        : 0
    }

    function startFinalizeCountdown() {
      updateFinalizeRemaining()
      if (finalizeTimer) {
        clearInterval(finalizeTimer)
        finalizeTimer = null
      }
      if (finalizeRemaining.value > 0) {
        finalizeTimer = setInterval(() => {
          updateFinalizeRemaining()
          if (finalizeRemaining.value <= 0) {
            clearInterval(finalizeTimer)
            finalizeTimer = null
          }
        }, 1000)
      }
    }

    function toggleRecording() {
      if (!context.root.api) {
        return
      }
      if (recording.value) {
        context.root.api.executeCommand('stopRecording', 'file')
      } else {
        context.root.api.executeCommand('startRecording', { mode: 'file' })
      }
    }

    // kept in sync with Jitsi's actual recording state via the
    // recordingStatusChanged event wired up in JoinMeeting.vue
    function setRecordingStatus(on) {
      const wasRecording = recording.value
      recording.value = on
      if (on) {
        // a new recording started: clear any stale link/popup state
        recordingStoppedAt.value = null
        recordingLink.value = ''
      } else if (wasRecording) {
        // recording just stopped: start the finalize window from now and
        // surface the download popup (the link may already have arrived)
        recordingStoppedAt.value = Date.now()
        startFinalizeCountdown()
        maybeShowDownloadPopup()
      }
    }

    // called from JoinMeeting.vue when the finished recording URL arrives.
    // JaaS provides the link shortly after recording *starts*, so only store
    // it here — the popup is gated on the recording having stopped.
    function setRecordingLink(link) {
      recordingLink.value = link
      maybeShowDownloadPopup()
    }

    function maybeShowDownloadPopup() {
      // only show once the recording has stopped and we actually have a link
      if (recording.value || !recordingStoppedAt.value || !recordingLink.value) {
        return
      }
      context.root.$bvModal.show('recording-download')
    }

    function downloadRecording() {
      // still finalizing — the file isn't ready to download yet
      if (!recordingLink.value || finalizeRemaining.value > 0) {
        return
      }
      // the recording URL is cross-origin; a hidden iframe triggers the
      // browser's save dialog instead of navigating away from the meeting
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = recordingLink.value
      document.body.appendChild(iframe)
    }

    async function launchInfo() {
      gaEvent({'ACTION': 'action', 'video_info': ''})
      await context.parent.askMeetingInfo()
      this.$bvModal.show('meeting-info')
    }

    function copyMeetingId() {
      navigator.clipboard.writeText(props.meetingInfo.ID)
    }

    function copy(type){
      if (!navigator.clipboard) {
        var copyElement = document.createElement('textarea')
        if (type == 'Invitation')
          copyElement.appendChild(document.createTextNode(context.parent.mmeetingInfo.inviteText))
        else if (type == 'App Link') {
          copyElement.appendChild(document.createTextNode(context.parent.mmeetingInfo.appLink))
        }
        else if (type == 'Web Link') {
          copyElement.appendChild(document.createTextNode(context.parent.mmeetingInfo.appLink))
        }
        copyElement.id = 'tempCopyToClipboard'
        document.body.append(copyElement)

        // select the text
        var range = document.createRange()
        range.selectNode(copyElement)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)

        // copy & cleanup
        document.execCommand('copy')
        window.getSelection().removeAllRanges()
        copyElement.remove()
      } else {
        let text = ''
        if (type == 'Invitation')
          text = context.parent.meetingInfo.inviteText
        else if (type == 'App Link') {
          text = context.parent.meetingInfo.appLink
        }
        else if (type == 'Web Link')
          text = context.parent.meetingInfo.webLink

        navigator.clipboard.writeText(text)
      }
      copied.value = type
      if (timeout.value) {
        clearTimeout(timeout.value)
        timeout.value = null
      }
      timeout.value = setTimeout( () => {
        copied.value = false
        updateInviteDropbox()
      }, 3000)
    }

    function isPM(date){
      if (typeof date === 'undefined'){
        return false;
      }
      return this.$moment(date).format('A') === 'PM';
    }

    function updateInviteDropbox(){
      if (copied.value) {
        if (copied.value == 'App Link')
          return context.root.$t('MEETING.COPY_APPLINK_DONE')
        else if (copied.value == 'Web Link')
          return context.root.$t('MEETING.COPY_WEBLINK_DONE')
        else
          return context.root.$t('MEETING.COPY_INVITE_DONE')
      } else {
        return context.root.$t('MEETING.COPY_INVITE')
      }
    }

    function launchMakeModerator() {
      this.$bvModal.show('modal-make-moderator')
    }

    function toggleSpeaker() {
      speaker.value = !speaker.value

      context.root.api.getRoomsInfo().then(rooms => {
        if (rooms.rooms) {
          rooms.rooms.forEach(room => {
            room.participants.forEach(participant => {
              setParticipantVolume(participant.id)
            })
          })
        }
      })
    }

    function setParticipantVolume(userId) {
      const volumeLvl = speaker.value ? 1 : 0
      context.root.api.executeCommand('setParticipantVolume', userId, volumeLvl)
    }

    return { launchInfo, isPM, updateInviteDropbox, copy, copyMeetingId, copied, launchMakeModerator,
      speaker, toggleSpeaker, isIos, setParticipantVolume, recording, toggleRecording, setRecordingStatus,
      recordingLink, setRecordingLink, downloadRecording, finalizeRemaining
    }
  }
}
</script>

<style scoped>
.speaker-icon {
  position: absolute;
  top: 12px;
  right: 24px;
  z-index: 1100;
  cursor: pointer;
}

.nav-item {
  width: 40px
}
.navbar {
  font-size: 24px;
  border-bottom: 1px solid #000000;
  z-index: 10;
  height: 44px
}

.meeting-title {
  font-size: 16px;
}

.recordBtn {
  font-size: 14px;
  line-height: 1;
  z-index: 1100;
}

.badge {
  position: absolute;
  padding: 2px 5px 4px 5px;
  right: 10px;
  color: #bbbbbb;
  top: 0
}

@media (min-width: 768px) {
  .navbar {
    z-index: 1030
  }
}
</style>
<style>
.info{
 background-color: #ffffff;
  color:#6E6E6E;
}

.info .modal-header .close{
  color:#6E6E6E;
}
.info h4{
  color: #282828;
}
.info .b-dropdown button + button{
  border-left:1px solid #BBBBBB;
  margin-left:0!important;
}
.info h4 small{ color:#6E6E6E; font-weight: 600; font-size:14px }
.info h4{ font-weight: 700; }
.info .recordingHint{ display:block; margin-top: 8px; font-size: 12px; font-weight: 400; color:#6E6E6E; line-height: 1.4; }
.info .recordingActions{ display:flex; justify-content:flex-end; margin-top: 24px; }
.info .closeInfo{position: absolute; right: 12px; top: 12px; cursor: pointer; font-size: 27px;color: #6E6E6E;line-height: 1; z-index: 10}
.info .details{ font-weight: 600; font-size: 12px; color: #6E6E6E}
.info .details > div{ line-height:45px;}
.info .details .detail a, .info .details .detail{ font-size: 16px; font-weight: 400; padding-left: 10px; color: #282828; line-height:30px}
.info .details .icon{ padding-right: 10px; vertical-align: text-bottom}
.info .details .numbers{ vertical-align: top; display: inline-block}
.info .smallDetails{ font-size: 12px;}
.info .smallDetails .float-left { padding-right: 12px;}
.info .smallDetails b{ color:#282828; display: block}
.info .btn-secondary { display: none}
.info .modal-footer { border-color:rgba(0,0,0,0.1); justify-content: space-between; border-top: 0px;}
.info .detail.modkey { margin-top: -0.6em; padding: 0 0 0 2rem; font-size: 17px}
.info .detail.phones { margin-top: -0.6em; padding: 2px 0 2px 2rem; font-size: 17px; color: #2166b2}
.info .detail.pin { margin-top: -0.75rem; padding: 0; }
.info .copymtg { margin-right: 5px; }
.infoTrigger{
  top: -1px;
  vertical-align: middle;
  cursor: pointer;
}

@media (max-width: 768px) {
  .mobilePush{
    position: relative;
    left: -50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBarJitsi.vue